import axiosInstance from './axiosInstance';
import { LoginCredentials, User, Organization } from '../types/Auth';

interface LoginResponse {
  token: string;
  role: string;
  invitation: any;
  current_onboarding_step: any;
}

export const authService = {
  async login(credentials: LoginCredentials): Promise<LoginResponse> {
    try {
      const response = await axiosInstance.post('/studio/auth/login', credentials);
      return response.data;
    } catch (error: any) {
      console.error('Login error:', error);
      throw new Error(
        error.response?.data?.message || 
        error.response?.data?.detail || 
        error.message || 
        'Network error'
      );
    }
  },

  async getCurrentUser(): Promise<User> {
    try {
      const response = await axiosInstance.get('/current_user');
      return response.data;
    } catch (error: any) {
      console.error('Get current user error:', error);
      throw new Error(
        error.response?.data?.message || 
        error.response?.data?.detail || 
        error.message || 
        'Failed to get current user'
      );
    }
  },

  async getOrganizations(): Promise<Organization[]> {
    try {
      const response = await axiosInstance.get('/studio/configuration/organization');
      return response.data;
    } catch (error: any) {
      console.error('Get organizations error:', error);
      throw new Error(
        error.response?.data?.message || 
        error.response?.data?.detail || 
        error.message || 
        'Failed to get organizations'
      );
    }
  },

  async logout(): Promise<{ success: boolean }> {
    try {
      await axiosInstance.post('/studio/auth/logout');
      return { success: true };
    } catch (error) {
      console.error('Logout error:', error);
      return { success: true }; // Still consider it successful for local cleanup
    }
  },

  async validateToken(): Promise<{ valid: boolean; user?: any }> {
    try {
      const response = await axiosInstance.get('/auth/validate');
      return {
        valid: true,
        user: response.data.user,
      };
    } catch (error) {
      console.error('Token validation error:', error);
      return { valid: false };
    }
  },
};